<template>
  <div class="container">
    <!-- HEADER -->
    <nav class="navbar navbar-expand-lg navbar-light" style="border-bottom: 2px solid #5a5a5a; background-color: white;">
      <div class="col-3" style="text-align: left;">
        <a class="navbar-brand" href="#"><img src="./../assets/CerealCityScienceLogo.png" style="max-height: 70px;" alt=""></a>
      </div>
      <div class="col-6 text-center">
        <h2 style="color: #5a5a5a;">Student Journals</h2>
      </div>
      <div class="col-3"></div>
    </nav>
    <!-- CONTENT WRAPPER -->
    <div id="contentWrapper" class="row h-100" style="margin:0; padding: 80px 0px 80px 0px;">
    <!-- Main Content -->
    <div class="col-9 mx-auto h-100" style="margin:0px; padding: 10px;">
    <div class="col-8 mx-auto">
    <div class="card" style="background-color: rgba(255, 255, 255, 0.9);">
    <div class="card-body text-center">
      <div id="login">
          <transition name="fade">
              <div v-if="performingRequest" class="loading">
                  <p>Loading...</p>
              </div>
          </transition>
          <section>
              <div class="col1">
                  <h1>Welcome!</h1>
              </div>
              <div class="col2">
                  <form v-if="showLoginForm" @submit.prevent>
                      <h3>Please sign in.</h3>
                      <label for="email1">Email</label>
                      <input v-model.trim="loginForm.email" type="text" placeholder="you@email.com" id="email1" />
                        <br>
                      <label for="password1">Password</label>
                      <input v-model.trim="loginForm.password" type="password" placeholder="******" id="password1" />
                        <br>
                      <button @click="login" class="button">Log In</button>

                      <div class="extras">
                          <a @click="togglePasswordReset">Forgot Password</a>
                          <!-- <a @click="toggleForm">Create an Account</a> -->
                      </div>
                  </form>

                  <form v-if="showForgotPassword" @submit.prevent class="password-reset">
                      <div v-if="!passwordResetSuccess">
                          <h1>Reset Password</h1>
                          <p>We will send you an email to reset your password</p>

                          <label for="email3">Email</label>
                          <input v-model.trim="passwordForm.email" type="text" placeholder="you@email.com" id="email3" />

                          <button @click="resetPassword" class="button">Submit</button>

                          <div class="extras">
                              <a @click="togglePasswordReset">Back to Log In</a>
                          </div>
                      </div>
                      <div v-else>
                          <h1>Email Sent</h1>
                          <p>check your email for a link to reset your password</p>
                          <button @click="togglePasswordReset" class="button">Back to login</button>
                      </div>
                  </form>
                  <transition name="fade">
                      <div v-if="errorMsg !== ''" class="error-msg">
                          <p>{{ errorMsg }}</p>
                      </div>
                  </transition>
              </div>
          </section>
      </div>
    </div>
    </div>
    </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('./../firebase/firebase.js');

export default {
    data() {
        return {
            loginForm: {
                email: '',
                password: ''
            },
            passwordForm: {
                email: ''
            },
            showLoginForm: true,
            showForgotPassword: false,
            passwordResetSuccess: false,
            performingRequest: false,
            errorMsg: ''
        }
    },
    computed:{
      ...mapState([ 'userProfile' ])
    },
    created() {

    },
    methods: {
        toggleForm() {
            this.errorMsg = ''
            this.showLoginForm = !this.showLoginForm
        },
        togglePasswordReset() {
            if (this.showForgotPassword) {
                this.showLoginForm = true
                this.showForgotPassword = false
                this.passwordResetSuccess = false
            } else {
                this.showLoginForm = false
                this.showForgotPassword = true
            }
        },
        login() {
            this.performingRequest = true

            fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
                this.$store.commit('SET_CURRENT_USER', user.user)
                this.$store.dispatch('fetchUserProfile')

            }).then(() => {
              this.performingRequest = false
              this.$router.push('/dashboard')  
            }).catch(err => {
                console.log(err)
                this.performingRequest = false
                this.errorMsg = err.message
            })
        },
        resetPassword() {
            this.performingRequest = true

            fb.auth.sendPasswordResetEmail(this.passwordForm.email).then(() => {
                this.performingRequest = false
                this.passwordResetSuccess = true
                this.passwordForm.email = ''
            }).catch(err => {
                console.log(err)
                this.performingRequest = false
                this.errorMsg = err.message
            })
        }
    }
}
</script>
<style lang="css" scoped>
.chk {
  margin-left: 23px;
}
#contentWrapper {
  background: url('./../assets/bg.svg');
  background-size: 100%;
  background-color: white;
}
</style>
